import Container from "components/wrewards-ui-kit/Container";
import React, { useState } from "react";
import styled from "styled-components";
import Arrow from "/public/images/icons/arrow.svg";
import Providers from "./Providers";
import SlotsSection from "./SlotsSection";
import { FindSlotGamesSort } from "hooks/slots/useSlotGames";
import SearchGames from "./SearchGames";
import PopularSlots from "./PopularSlots";
import {
  SlotsAnimatedBg,
  ComponentTitle,
  ComponentTitleBlock,
  NavigationItem,
  NavigationWrapper,
  SearchBlock,
  SearchSection,
} from "./elements";
import WrewardsDropdown from "components/wrewards-ui-kit/Dropdown";
import useSlotProviders from "hooks/slots/useSlotProviders";
import CherrySvg from "/public/images/NewAllGames/icons/cherry.svg";
import { useGamesPageNavItems } from "hooks/games/useGamesPageNavItems";
import { useAddSlotsRouter } from "hooks/games/useAddSlotsRoutem";

const controlOptions = [
  {
    value: FindSlotGamesSort.NAME_ASC,
    label: "A-z",
  },
  {
    value: FindSlotGamesSort.NAME_DESC,
    label: "Z-a",
  },
  {
    value: FindSlotGamesSort.MOST_POPULAR,
    label: "Most Popular",
  },
  {
    value: "",
    label: "All",
  },
];

function AllSlots() {
  const [sort, setSort] = useState("");
  const { data } = useSlotProviders();
  const { navItems } = useGamesPageNavItems();
  const {
    isNew,
    isFavorite,
    isHot,
    isChallenge,
    slotsGridTitle,
    isTabActive,
    challengeParams,
    removeChallengeFilter,
    provider,
    setProvider,
  } = useAddSlotsRouter();

  return (
    <Container>
      <Space>
        <SearchSection>
          <SlotsAnimatedBg />
          <SearchBlock>
            <h2 className="title">
              <CherrySvg className={"icon"} />
              Slots
            </h2>
            <p className="label">100+ Games to search!</p>
            <div className="search-input">
              <SearchGames />
            </div>
          </SearchBlock>
        </SearchSection>

        <NavigationWrapper>
          <div className="items links">
            {navItems.map((item) => (
              <NavigationItem key={item.path} data-active={isTabActive(item.path)} href={item.path}>
                {item.icon}
                {item.label}
              </NavigationItem>
            ))}
          </div>
          <div className="items sorts">
            <WrewardsDropdown
              value={sort}
              onChange={({ value }) => setSort((p) => (p === value ? "" : value))}
              items={controlOptions}
              prefix="Sort By:"
              icon={<Arrow />}
            />
          </div>
        </NavigationWrapper>

        <div>
          <ComponentTitleBlock>
            <ComponentTitle>
              <CherrySvg />
              Providers
            </ComponentTitle>
          </ComponentTitleBlock>

          <Providers
            providers={data ?? []}
            onProviderSelect={(prov) => setProvider(provider === prov ? "" : prov)}
            activeProviders={[provider]}
          />
        </div>

        {(isNew || isFavorite || isHot || isChallenge) && (
          <PopularSlots
            title={slotsGridTitle}
            isFavorite={isFavorite}
            isNewReleases={!isFavorite}
            isHot={isHot}
            isChallenge={isChallenge}
            provider={provider}
            isGrid
            challengeParams={challengeParams}
            removeChallengeFilter={removeChallengeFilter}
          />
        )}

        {!isNew && !isFavorite && !isHot && !isChallenge && (
          <div style={{ position: "relative" }}>
            <ComponentTitleBlock>
              <ComponentTitle>
                <CherrySvg />
                All Slots
              </ComponentTitle>
            </ComponentTitleBlock>

            <SlotsSection provider={provider} sort={sort} />
          </div>
        )}
      </Space>
    </Container>
  );
}
const Space = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-bottom: 40px;
`;

export default AllSlots;
